
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const location = useLocation();
  
  const scrollToSection = (sectionId: string) => {
    if (location.pathname !== '/') {
      window.location.href = `/#${sectionId}`;
      return;
    }
    
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm shadow-sm z-50">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center space-x-3">
            <img 
              src="/images/618966bfb4b4e94a093e590c5e5c9e3e.png"
              alt="RENABACH Logo" 
              className="h-10 w-auto"
            />
            <div className="text-2xl font-bold text-blue-600" style={{ fontFamily: '"Pacifico", serif' }}>
              Renabach
            </div>
          </Link>
          
          <nav className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('inicio')}
              className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer"
            >
              Inicio
            </button>
            <button 
              onClick={() => scrollToSection('sobre-nosotros')}
              className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer"
            >
              Sobre Nosotros
            </button>
            <button 
              onClick={() => scrollToSection('universidades')}
              className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer"
            >
              Universidades
            </button>
            <Link 
              to="/programas"
              className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer"
            >
              Programas
            </Link>
            <button 
              onClick={() => scrollToSection('contacto')}
              className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer"
            >
              Contacto
            </button>
          </nav>
          
          <div className="md:hidden">
            <button className="text-gray-700 hover:text-blue-600">
              <i className="ri-menu-line text-xl"></i>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}
